import * as React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {Home, About, LogIn, Book, NotFound} from '../components/pages';

import LoggedOutRoute from './LoggedOutRoute';
import LoggedInRoute from './LoggedInRoute';

const Pages = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LoggedOutRoute component={LogIn} />} />
      <Route path="/about" element={<LoggedOutRoute component={About} />} />
      <Route path="/log-in" element={<LoggedOutRoute component={LogIn} />} />
      <Route path="/home" element={<LoggedInRoute component={Home} />} />
      <Route path="/book" element={<LoggedInRoute component={Book} />} />
      <Route element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default Pages;
